// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"68b9fa48","556":"33fa02dc"}[chunkId] + ".chunk.css";
};